import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ScanPlayFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ScanPlayFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M4.5 6.5c0-1.1.9-2 2-2H10v-3H6.5c-2.76 0-5 2.24-5 5V10h3V6.5ZM17.5 1.5H14v3h3.5c1.1 0 2 .9 2 2V10h3V6.5c0-2.76-2.24-5-5-5ZM19.5 17.5c0 1.1-.9 2-2 2H14v3h3.5c2.76 0 5-2.24 5-5V14h-3v3.5ZM4.5 17.5V14h-3v3.5c0 2.76 2.24 5 5 5H10v-3H6.5c-1.1 0-2-.9-2-2ZM9 16.5l7.5-4.5L9 7.5v9Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ScanPlayFilled;